import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "sp-icon"
    }}>{`sp-icon`}</h1>
    <p><strong parentName="p">{`Since:`}</strong>{` UXP v4.1`}</p>
    <p>{`Display a named icon.`}</p>
    <p><img alt="Icons" src={require("../../assets/sp-icon.png")} /></p>
    <p><strong parentName="p">{`See`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://spectrum.adobe.com/page/icons/"
        }}>{`https://spectrum.adobe.com/page/icons/`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://opensource.adobe.com/spectrum-web-components/components/icon"
        }}>{`https://opensource.adobe.com/spectrum-web-components/components/icon`}</a></li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-icon name="ui:Magnifier"></sp-icon>
`}</code></pre>
    <h2 {...{
      "id": "sizes"
    }}>{`Sizes`}</h2>
    <p>{`Icons can be rendered in various sizes by specifying a T-Shirt size with a `}<inlineCode parentName="p">{`size`}</inlineCode>{` attribute.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-icon size="xxs" name="ui:Magnifier"></sp-icon>
<sp-icon size="xs" name="ui:Magnifier"></sp-icon>
<sp-icon size="s" name="ui:Magnifier"></sp-icon>
<sp-icon size="m" name="ui:Magnifier"></sp-icon>
<sp-icon size="l" name="ui:Magnifier"></sp-icon>
<sp-icon size="xl" name="ui:Magnifier"></sp-icon>
<sp-icon size="xxl" name="ui:Magnifier"></sp-icon>
`}</code></pre>
    <h2 {...{
      "id": "built-in-icons"
    }}>{`Built-in Icons`}</h2>
    <p>{`Spectrum UXP supplies the `}<a parentName="p" {...{
        "href": "https://spectrum.adobe.com/page/icons/"
      }}>{`Spectrum UI icons`}</a>{`. They are named as follows:`}</p>
    <ul>
      <li parentName="ul">{`AlertMedium`}</li>
      <li parentName="ul">{`AlertSmall`}</li>
      <li parentName="ul">{`ArrowDownSmall`}</li>
      <li parentName="ul">{`ArrowLeftMedium`}</li>
      <li parentName="ul">{`ArrowUpSmall`}</li>
      <li parentName="ul">{`Asterisk`}</li>
      <li parentName="ul">{`CheckmarkMedium`}</li>
      <li parentName="ul">{`CheckmarkSmall`}</li>
      <li parentName="ul">{`ChevronDownMedium`}</li>
      <li parentName="ul">{`ChevronDownSmall`}</li>
      <li parentName="ul">{`ChevronLeftLarge`}</li>
      <li parentName="ul">{`ChevronLeftMedium`}</li>
      <li parentName="ul">{`ChevronRightLarge`}</li>
      <li parentName="ul">{`ChevronRightMedium`}</li>
      <li parentName="ul">{`ChevronRightSmall`}</li>
      <li parentName="ul">{`ChevronUpSmall`}</li>
      <li parentName="ul">{`CornerTriangle`}</li>
      <li parentName="ul">{`CrossLarge`}</li>
      <li parentName="ul">{`CrossMedium`}</li>
      <li parentName="ul">{`CrossSmall`}</li>
      <li parentName="ul">{`DashSmall`}</li>
      <li parentName="ul">{`DoubleGripper`}</li>
      <li parentName="ul">{`FolderBreadcrumb`}</li>
      <li parentName="ul">{`HelpMedium`}</li>
      <li parentName="ul">{`HelpSmall`}</li>
      <li parentName="ul">{`InfoMedium`}</li>
      <li parentName="ul">{`InfoSmall`}</li>
      <li parentName="ul">{`Magnifier`}</li>
      <li parentName="ul">{`More`}</li>
      <li parentName="ul">{`SkipLeft`}</li>
      <li parentName="ul">{`SkipRight`}</li>
      <li parentName="ul">{`Star`}</li>
      <li parentName="ul">{`StarOutline`}</li>
      <li parentName="ul">{`SuccessMedium`}</li>
      <li parentName="ul">{`SuccessSmall`}</li>
      <li parentName="ul">{`TripleGripper`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      